import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import CustomButton from "../button/Button";
import CustomSelect from "../select/Select";
import ToggleSwitch from "../toggleSwitch/ToggleSwitch";
import { fetchInstallersDisabled } from "../../components/functions/Functions";

const SearchBar = ({
  fields,
  setData,
  url,
  handleCloseModal,
  setBusqueda,
  busqueda,
  initial,
  perfiles,
  dataOriginal,
  isOn,
  setIsOn,
  width,
  height,
  setFilteredBase,
  specialties,
}) => {
  const API_URL = process.env.REACT_APP_API_URL || "https://check.gruponxt.com";
  const [inhabilitado, setInhabilitado] = useState(false);
  const { empresaId } = useParams();
  const areObjectsEqual = (obj1, obj2) => {
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
    if (keys1.length !== keys2.length) return false;

    return keys1.every((key) => obj1[key] === obj2[key]);
  };

  useEffect(() => {
    if (
      url === "contactos-instaladores" &&
      !areObjectsEqual(busqueda, initial)
    ) {
      setInhabilitado(true);
    } else {
      setInhabilitado(false);
      setData(dataOriginal);
    }
  }, [busqueda]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "perfil") {
      // Construir objeto perfil
      setBusqueda({
        ...busqueda,
        perfil: {
          descripcion: e.target.innerHTML,
          name: value.toUpperCase().replace(/\s/g, "_"), // Convierte el nombre
        },
      });
    } else if (name === "especialidades") {
      const selected = specialties?.find((esp) => esp.id === value);
      setBusqueda({
        ...busqueda,
        especialidades: selected
          ? { id: selected.id, nombre: selected.nombre }
          : {},
      });
    } else {
      setBusqueda({
        ...busqueda,
        [name]: value,
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (url === "contactos-instaladores" && inhabilitado) {
        if (busqueda.buscarInhabilitados) {
          const dataDisabled = await fetchInstallersDisabled(
            API_URL,
            empresaId
          );
          dataOriginal = dataDisabled.sort((a, b) =>
            (a.nombre || "").localeCompare(b.nombre || "")
          );
          setFilteredBase(dataOriginal);
        }

        const dataResulted = dataOriginal.filter((item) => {
          // Si se está buscando por nombre
          if (busqueda.nombreInstalador) {
            const fullName = `${item.nombre || ""} ${
              item.apellidos || ""
            }`.toLowerCase();
            const searchName = busqueda.nombreInstalador.toLowerCase();
            return fullName.includes(searchName);
          }

          // Si se está buscando por gafete
          if (busqueda.numGafete) {
            return item.numGafete
              ?.toLowerCase()
              .includes(busqueda.numGafete.toLowerCase());
          }

          return true;
        });
        setFilteredBase(dataResulted);
      } else if (
        url === "contactos-instaladores" &&
        areObjectsEqual(busqueda, initial)
      ) {
        handleCloseModal();
        return;
      } else {
        const response = await axios.post(`${API_URL}/api/${url}`, busqueda, {
          withCredentials: true,
          headers: {
            "Content-Type": "application/json",
          },
        });
        if (url === "empresas-por-criterios") {
          setData(response.data);
          setFilteredBase(response.data);
        } else {
          const sortedData = response.data.sort((a, b) =>
            a.nombre.localeCompare(b.nombre)
          );
          setData(sortedData);
        }
      }
      handleCloseModal();
    } catch (error) {
      console.error("Error al buscar trabajos:", error);
    }
  };

  const handleReset = () => {
    setData(dataOriginal);
    setBusqueda(initial);
    setIsOn(false);
    setFilteredBase(dataOriginal);
  };

  return (
    <form onSubmit={handleSubmit}>
      {fields.map((field) => (
        <div key={field.name}>
          <label>{field.label}:</label>
          {field.name === "perfil" ? (
            <CustomSelect
              options={perfiles.map((perfil) => ({
                value: perfil.name,
                name: perfil.descripcion,
                icon: perfil.icon,
              }))}
              value={busqueda.perfil?.name || ""}
              name={field.name} // Añade el nombre del campo
              onChange={handleChange}
              width={width}
              height={height}
            />
          ) : field.name === "buscarInhabilitados" ? (
            <ToggleSwitch
              isOn={isOn}
              setIsOn={setIsOn}
              onChange={handleChange}
              name={field.name}
            />
          ) : field.name === "especialidades" ? (
            <CustomSelect
              options={specialties?.map((especialidades) => ({
                value: especialidades.id,
                name: especialidades.nombre,
              }))}
              placeholder={"Selecciona una especialidad"}
              value={busqueda.especialidades?.id || ""}
              name={field.name} // Añade el nombre del campo
              onChange={handleChange}
              width={width}
              height={"30px"}
              heightOption={"200px"}
            />
          ) : (
            <input
              type="text"
              name={field.name}
              value={busqueda[field.name] || ""}
              onChange={handleChange}
            />
          )}
        </div>
      ))}
      <div
        className="d-flex align-items-stretch justify-content-between"
        style={{ marginTop: "20px" }}
      >
        <div className="d-flex align-items-center">
          <CustomButton
            text={"Cancelar"}
            onClick={handleCloseModal}
            color={"#30495C"}
            border={"none"}
            background={"transparent"}
            fontStyle={"normal"}
            fontWeight={400}
            fontSize={"10px"}
            width={"41px"}
            height={"10px"}
            style={{ textDecoration: "underline" }}
            type={"button"}
          />
        </div>
        <div
          className="d-flex align-items-stretch justify-content-between"
          style={{ width: "112px" }}
        >
          <CustomButton
            text={"Limpiar"}
            onClick={handleReset}
            color={"#FFFFFF"}
            border={"none"}
            background={"#223D51"}
            fontStyle={"normal"}
            fontWeight={700}
            fontSize={"10px"}
            width={"80px"}
            height={"24px"}
            type={"button"}
          />

          <CustomButton
            text={"Ok"}
            color={"#FFFFFF"}
            border={"none"}
            background={"#62C776"}
            fontStyle={"normal"}
            fontWeight={700}
            fontSize={"10px"}
            width={"29px"}
            height={"24px"}
          />
        </div>
      </div>
    </form>
  );
};

export default SearchBar;
